import * as React from 'react';

import {LaunchBarApp} from '../../view/apps/LauncherBarApp/LaunchBarApp';
import {SearchPanel} from '../../view/apps/SearchPanel/SearchPanel';
import {SettingsPanel} from '../../view/apps/SettingsPanel/SettingsPanel';
import {WorkspacesPanel} from '../../view/apps/WorkspacesPanel/WorkspacesPanel';
import {DirectoryPanel} from '../../view/apps/DirectoryPanel/DirectoryPanel';
import {LaunchBarSettings} from '../../view/apps/SettingsPanel/LaunchBar/LaunchBarSettings';
import {AboutSettings} from '../../view/apps/SettingsPanel/About/AboutSettings';
import {ProfileSettings} from '../../view/apps/SettingsPanel/Profile/ProfileSettings';

import {ROUTES} from './consts';

export interface AppRoute {
    Component: React.ComponentType<any> | React.FC;
    exact: boolean;
    path: string;
    children?: AppRoute[];
}

export const panelRoutes: AppRoute[] = [
    {
        Component: SearchPanel,
        exact: true,
        path: ROUTES.SEARCH
    },
    {
        Component: DirectoryPanel,
        exact: true,
        path: ROUTES.DIRECTORY
    },
    {
        Component: WorkspacesPanel,
        exact: true,
        path: ROUTES.WORKSPACES
    },
    {
        Component: SettingsPanel,
        exact: false,
        path: ROUTES.SETTINGS_PANEL
    }
];

export const settingsPanelRoutes: AppRoute[] = [
    {
        Component: LaunchBarSettings,
        exact: true,
        path: ROUTES.SETTINGS_PANEL_LAUNCHBAR
    },
    {
        Component: AboutSettings,
        exact: true,
        path: ROUTES.SETTINGS_PANEL_ABOUT
    },
    {
        Component: ProfileSettings,
        exact: true,
        path: ROUTES.SETTINGS_PANEL_PROFILE
    }
];

// Default routes for launchpad
export const routes: AppRoute[] = [
    {
        Component: LaunchBarApp,
        exact: true,
        path: ROUTES.HOME
    },
    ...panelRoutes,
    ...settingsPanelRoutes
];

// Routes that are only accessible to Omnibar users
export const omnibarRoutes: AppRoute[] = [
    {
        Component: SearchPanel,
        exact: true,
        path: ROUTES.HOME
    }
];
